import React from "react"
import { ListItem, ListOptions } from "./components/listItem"
import { Scrollbars } from 'react-custom-scrollbars-2';


export type ListProps = {
  options: ListOptions[]
}
export const List: React.FC<ListProps> = (props) => {
  const { options } = props;
  return (
    <div style={{height: '100%'}}>
      <Scrollbars autoHide autoHideDuration={1000}>
        {
        options.map(option => {

          return <ListItem key={option.id} {...option} />
        })
      }
      </Scrollbars>
      
    </div>
  )
}